/**
 * 邮件正文body修改为position:absolute;让其高度只根据内部内容变化，不受外部窗体高度的变化。防止出现递归增高的问题。
 *
 * 关于 body box-sizing: border-box; 的说明：
 * 有一份邮件自带style 其中body 的css有 height:100%; padding: 5; 会形成死循环
 * 外面的html标签的高度由body的高度决定，假如最初拿到的body高度是100，html的高度被设置为100，然后body的高度又被设置为100+10（10是上下padding），这样就形成了死循环。
 */

const readMailCss = `
<style type="text/css">
.frame-context-menu {
  position: absolute;
  background: #ffffff;
  padding: 8px 0;
  color: #262a33;
  font-size: 14px;
  box-shadow: 0px 2px 4px rgba(38, 42, 51, 0.1);
  border-radius: 4px;
  min-width: 88px;
  z-index: 1;
}
.frame-context-menu::before {
  content: ' ';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: calc(200% - 2px);
  height: 200%;
  border-radius: 8px;
  border: 1px solid rgba(38, 42, 51, 0.12);
  transform-origin: 0 0;
  -webkit-transform-origin: 0 0;
  transform: scale(0.5, 0.5);
  -webkit-transform: scale(0.5, 0.5);
}
.frame-context-menu p {
  margin: 0;
  padding: 8px 16px;
  cursor: pointer;
  line-height: 14px;
  position: relative;
  z-index: 2;
}
.frame-context-menu p:hover {
  background: #f0f0f1;
}
.mce-match-marker {
  background: #fce1b7;
}
.mce-match-marker-selected {
  background: #f9b54c;
}

.MsoNormal {
  margin: 0;
}

</style>
`;

const readMailScript = `
<script type="text/javascript">

// 接听外部消息处理事件的数组
var messageHandles = [];

// 接受容器发来的通知消息
window.addEventListener('message', (event)=>{
  execTask(event, messageHandles);
});



// 读信高度 等尺寸问题
// 监听body变化 同步高度到iframe 外层
function resizeSize() {
  // var parentWindow = parent.window;
  // 创建观察器
  // var MuationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
  if (!ResizeObserver) return;
  iframeObserver = new ResizeObserver(entries => {
    // 重设iframe尺寸
    // parentWindow.readMail.throttleResetIframeSize();
    postParentMessage('readMail_resizeSize')
  });
  // 观察对象 iframe内容wrapper
  var documentBody = document.body;
  var config = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
  };
  // iframeObserver.observe(documentBody, config);
  iframeObserver.observe(documentBody);
};


// 监听页面完成加载
function documentReady() {
  window.addEventListener("DOMContentLoaded", function(event) {
    postParentMessage('readMail_mailLoadOver')
  });
};

/**
 * 与父窗体消息通信
 */
function postParentMessage(name, value){
  if(window.parent &&  window.parent.postMessage){
    if(window.parent.nativePostMessage) {
      window.parent.nativePostMessage({
        name,
        value
      });
      return;
    }
    window.parent.postMessage({
      name,
      value
    });
  }
}


/**
 * 初始化
 */
(function() {
  var parentWindow = parent.window;
  if (!parentWindow || !parentWindow.document || !document) return;
  resizeSize();
  documentReady();
}())
</script>
`;

const headers = `
<head>
<base target="_blank" />
<style type="text/css">
// img{cursor:zoom-in;}
</style>
<style id="imgMaxWidth" type="text/css">
</style>
<style id="cloudAttachStyle" type="text/css">
</style>
<style id="ntes_link_color" type="text/css">a,td a{color:#386EE7}</style>
<style id="blockquoteStyle" type="text/css">blockquote{}</style>
${readMailCss}
<style type="text/css">
  body{
    font-size:14px;
    font-family:arial,verdana,sans-serif;
    line-height:1.666;
  }
</style>
</head>
`;

const defaultMailCss = `
<style type="text/css">
body{
  padding:0;
  margin:0;
  overflow:auto;
  white-space:normal;
  word-wrap:break-word;
  min-height:100px;
  position:absolute;
  box-sizing: border-box;
  width:100%;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
}
html{
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
}
html::-webkit-scrollbar {
  display: none; /* WebKit browsers */
}
body::-webkit-scrollbar {
  display: none; /* WebKit browsers */
}
td, input, button, select, body{font-family:Helvetica, 'Microsoft Yahei', verdana}
pre {white-space:pre-wrap;white-space:-moz-pre-wrap;white-space:-pre-wrap;white-space:-o-pre-wrap;word-wrap:break-word;width:95%}
th,td{font-family:arial,verdana,sans-serif;line-height:1.666}
img{ border:0}
header,footer,section,aside,article,nav,hgroup,figure,figcaption{display:block}
blockquote{margin-right:0px}
a > img {cursor:pointer !important}
</style>
`;

const mailContentWrapper = (content: string) => `
${content}
${readMailScript}
`;

export const readWrapper = (mailContent?: string) =>
  `<!DOCTYPE html><html>${headers}${mailContentWrapper(mailContent || '')}${defaultMailCss}</html>`;
